export default __webpack_public_path__ + "static/media/amparo-material-2.f89c4e09.webp";